import React, { useRef } from 'react';
import { Image, View } from 'react-native';
import { Button } from 'react-native-paper';

import logo_purple from '../../../assets/images/logo_purple.png';
import { AppHeader, VideoPlayer } from '../../../components/common';
import { AppText } from '../../../components/form';
import styles from './styles';

export default function HowItWorksLivePersonalTrainer({ navigation }) {
  const video = useRef(null);

  const handleContinue = () => {
    // video.current.stopAsync();
    navigation.navigate('Profile Trainer', { screen: 'Selecione as datas' });
  };
  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Como Funciona?" />
      <View style={styles.content}>
        <Image style={styles.logo} source={logo_purple} />
        <View style={styles.cardContent}>
          <div>
           <VideoPlayer url="https://player.vimeo.com/video/651966263?h=cbbe97697a" />
          </div>
          {/* <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <TouchableOpacity
              onPress={() => {
                if (status) {
                  video.current.pauseAsync();
                } else {
                  video.current.presentFullscreenPlayer();
                  video.current.playAsync();
                }
              }}
              style={styles.buttonVideo}
            >
              <Icon name={`${status ? 'stop' : 'play'}-circle`} style={styles.iconVideo} />
            </TouchableOpacity>
          </View> */}
          <Button mode="contained" onPress={handleContinue} style={styles.button} labelStyle={styles.textButton}>Avançar</Button>
        </View>
        <AppText />
      </View>
    </>
  );
}
